module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "demo"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("This pluggin provides the 'vue-fuse' component, which can be dropped into your app. The component UI is a barebones <input> tag, as shown below.")]), _c('p', [_vm._v(" The component also takes a number of props, that are used to configure the search and define the event that is eminated when the search results update.")]), _vm._v(" "), _c('vue-fuse', {
    attrs: {
      "placeholder": "Search for bikes",
      "keys": _vm.keys,
      "list": _vm.bikes,
      "event-name": "bikesChanged",
      "inputChangeEventName": "bikeSearchInputChanged",
      "default-all": _vm.defaultAllToggle,
      "search": _vm.termtwo
    }
  }), _vm._v(" "), _c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.toggle
    }
  }), _vm._v("defaultAll")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" you can bind to the :search prop as well, so that you can map your own data source to the component. (try typing in the input here -->)\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.termtwo),
      expression: "termtwo"
    }],
    domProps: {
      "value": (_vm.termtwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.termtwo = $event.target.value
      }
    }
  })]), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.componentResults), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "demo"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Instead of using the component, you can use the $search instance method to execute a search programatically")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    attrs: {
      "type": "search"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.methodResults), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "demo"
  }, [_c('h2', [_vm._v("here's a list of bikes to search through!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list"
    }
  }, [_c('ul', _vm._l((_vm.bikes), function(bike) {
    return _c('li', {
      key: bike.model.id
    }, [_vm._v(_vm._s(bike.brand) + " | " + _vm._s(bike.model.name) + " " + _vm._s(bike.model.id))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('code', [_vm._v("vue-fuse")]), _vm._v(" component demo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('code', [_vm._v("$search")]), _vm._v(" instance method demo")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e720b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 14
// module chunks = 1